var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-data-iterator',{attrs:{"icon":_vm.icon,"title":_vm.title,"show-actions":_vm.showActions,"card-component":_vm.cardComponent,"route-name":_vm.routeName,"namespace":_vm.namespace,"store-action":_vm.storeAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }